(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.active,
          expression: "active"
        }],
        staticClass: "nx-tab-pane",
        attrs: {
          "role": "tabpanel",
          "tab": _vm.name
        }
      }, [_vm._t("default")], 2);
    },
    name: 'nx-tab-pane',
    inject: {
      rootTabs: {
        from: 'rootTabs',
        default: function _default() {
          /* istanbul ignore next */
          return this.$parent;
        }
      }
    },
    props: {
      label: {
        type: String
      },
      name: {
        type: String
      },
      disabled: {
        type: Boolean
      }
    },
    computed: {
      active: function active() {
        return this.rootTabs.currentName === this.name;
      },
      transitionName: function transitionName() {
        return this.rootTabs.prevIndex > this.rootTabs.currentIndex ? 'nx-tab-slide-right' : 'nx-tab-slide-left';
      }
    },
    watch: {
      label: function label() {
        this.rootTabs.$forceUpdate();
      },
      disabled: function disabled() {
        this.rootTabs.$forceUpdate();
      }
    },
    created: function created() {
      this.rootTabs.$_addPane(this);
    },
    destroyed: function destroyed() {
      this.rootTabs.$_removePane(this);
    }
  };
  _exports.default = _default2;
});